module.exports = __webpack_public_path__ + "static/media/Lucario.9497dbd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Lucario.png
// module id = 65
// module chunks = 0